import { Reveal } from "@/components/Motion";
import { EXAM_INFO } from "@/data/content";
import { AlertTriangle } from "lucide-react";
 
const ExamInfo = () => {
  return (
    <section
      id="exam-info"
      data-testid="exam-info"
      className="relative py-28 md:py-36 bg-[#0a0a12]"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <Reveal>
          <span className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#16fcfb]">
            [ 006 ] HCASP Exam Info
          </span>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-display font-700 text-4xl md:text-5xl leading-[1.05] tracking-tight text-white">
            Exam format & logistics.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 font-body text-base text-white/65 leading-relaxed">
            The HCASP exam uses Computerized Adaptive Testing (CAT). Review the
            key details below before scheduling your slot.
          </p>
        </Reveal>
 
        <Reveal delay={0.12}>
          <div className="mt-12 w-full overflow-x-auto rounded-2xl border border-[#3d414f]">
            <table
              className="w-full min-w-0 text-left"
              data-testid="exam-info-table"
            >
              <tbody>
                {EXAM_INFO.map((row, i) => (
                  <tr
                    key={row.label}
                    className={`border-b border-[#3d414f] last:border-b-0 ${i % 2 === 0
                        ? "bg-[#07070c]"
                        : "bg-[#404452]/15"
                      }`}
                  >
                    <th
                      className="
                align-top
                w-2/5
                px-3 md:px-6
                py-4 md:py-5
                font-mono2
                text-[10px] md:text-sm
                uppercase
                tracking-[0.08em] md:tracking-[0.12em]
                text-[#97b8ff]
                font-500
                break-words
              "
                    >
                      {row.label}
                    </th>
 
                    <td
                      className="
                px-3 md:px-6
                py-4 md:py-5
                font-body
                text-sm md:text-base
                text-white
                break-words
              "
                    >
                      {row.value}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Reveal>
 
        {/* <Reveal delay={0.15}>
          <div className="mt-6 flex items-start gap-3 rounded-xl border border-[#4d4479] bg-[#4d4479]/15 p-5">
            <AlertTriangle size={18} className="text-[#97b8ff] mt-0.5 shrink-0" />
            <p className="font-body text-sm text-white/75 leading-relaxed">
              <span className="text-[#97b8ff] font-600">Notice:</span> The HCASP
              exam is delivered in English and is offered during specific annual
              appointment windows: March 1-31, June 1-30, September 1-30, and
              December 1-31.
            </p>
          </div>
        </Reveal> */}
      </div>
    </section>
  );
};
 
export default ExamInfo;
 
 